import PropTypes from 'prop-types';
import React from 'react';

export const style = {
  border: '0',
  borderRadius: '4px',
  padding: '8px 24px',
  color: '#fff',
  fontFamily: 'Roboto, sans-serif',
  fontWeight: '500',
  cursor: 'pointer',
};

const Button = ({
  children,
  clicked,
  background,
  disabled,
  type = 'button',
}) => (
  <>
    <button
      type={type}
      style={{ ...style, background }}
      onClick={clicked}
      disabled={disabled}
    >
      {children}
    </button>
  </>
);

Button.propTypes = {
  clicked: PropTypes.func,
  disabled: PropTypes.bool,
  background: PropTypes.string,
  type: PropTypes.oneOf(['submit', 'button', 'reset']),
  children: PropTypes.node.isRequired,
};

Button.defaultProps = {
  disabled: false,
  background: 'var(--petrol-color)',
  clicked: function clicked() {},
  type: 'button',
};

export default Button;
